import { v4 as uuidv4 } from 'uuid';
import { pageNotiActions as PageNotiActions } from '../../slices/pageNotificationSlice';

export function SuccessNotificationMessage(dispatch, msg) {
    let notiInfo = {
        id: uuidv4(),
        message: msg,
        status: 'success'
    };
    dispatch(PageNotiActions.setNotification(notiInfo));
}
export const WarningNotificationMessage = (dispatch, msg) => {
    let notiInfo = {
        id: uuidv4(),
        message: msg,
        status: 'warning'
    }
    dispatch(PageNotiActions.setNotification(notiInfo));
};
export const ErrorNotificationMessage = (dispatch, msg) => {
    let notiInfo = {
        id: uuidv4(),
        message: msg,
        status: 'error'
    }
    dispatch(PageNotiActions.setNotification(notiInfo));
}